import React, { useCallback, useMemo, useState } from 'react'
import { rem } from 'polished'
import useOfferList from 'hooks/Offers/useOfferList'
import OfferCarouselHeader from './common/OfferCarouselHeader'
import OfferCarouselFilters from './common/OfferCarouselFilters'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import useHolidayTypes from 'home/hooks/useHolidayTypes'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import qs from 'qs'

const SectionContainer = styled(VerticalSpacer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const OFFER_TYPES: App.OfferListOfferType[] = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel', 'tour', 'tour_v2']
const DEFAULT_PUBLIC_OFFER_PARAMS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  propertySubCategories: ['Ultra Lux'],
  sortBy: 'homepage',
}
const DEFAULT_UNIFIED_ENDPOINT_PARAMS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  holidayTypesScoped: ['Ultra Lux'],
  sortBy: 'vertical-ultralux',
}
interface Props {
  title?: React.ReactNode;
}

function UltraLuxOfferCarousel(props: Props) {
  const { title } = props
  const [selectedFilter, setSelectedFilter] = useState<string>()
  const isManualSortingEnabled = isManualSortingEnabledFor('ultralux')
  const defaultParams = isManualSortingEnabled ? DEFAULT_UNIFIED_ENDPOINT_PARAMS : DEFAULT_PUBLIC_OFFER_PARAMS
  const offerListFilters = useMemo(() => {
    return {
      ...defaultParams,
      ...{ holidayTypes: selectedFilter ? [selectedFilter] : undefined },
    }
  }, [defaultParams, selectedFilter])

  const offerList = useOfferList(offerListFilters)

  const filters = useHolidayTypes(defaultParams, 5)
  const toggleFilter = useCallback((name: string) => {
    setSelectedFilter(selectedFilter === name ? undefined : name)
  }, [selectedFilter])

  const to = useMemo(() => {
    if (offerListFilters.holidayTypes || offerListFilters.sortBy === 'value') {
      const query = {
        holidayTypes: offerListFilters.holidayTypes,
        sortBy: offerListFilters.sortBy === 'value' ? 'value' : undefined,
      }
      return `/ultra-lux?${qs.stringify(query, { arrayFormat: 'comma' })}`
    }
    return LOOKING_FOR_SOMETHING_ELSE_CONTENT.ultralux.to
  }, [offerListFilters])

  if ((offerList.offerIds.length === 0 && !selectedFilter)) {
    return null
  }

  return (
    <SectionContainer gap={20}>
      <LayoutContainer>
        <VerticalSpacer gap={20}>
          <OfferCarouselHeader allTo="/ultra-lux">
            {title ?? <>Indulge in <i>ultra lux</i> escapes</>}
          </OfferCarouselHeader>
          <OfferCarouselFilters
            options={filters}
            active={selectedFilter}
            onClick={toggleFilter}
          />
        </VerticalSpacer>
      </LayoutContainer>
      <OfferListCarousel
        filters={offerListFilters}
        mobileLimit={8}
      >
        <OfferCarouselLookingForSomethingElse to={to} />
      </OfferListCarousel>
    </SectionContainer>
  )
}

export default React.memo(UltraLuxOfferCarousel)
